import * as tslib_1 from "tslib";
import { HorizontalBar } from 'vue-chartjs';
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
const dbBackground = 'rgba(32, 36, 39, 1)';
let chart = class chart extends Vue {
    watchChartData() { this.updateData(); }
    get sum() {
        let total = 0;
        for (let key in this.chartData) {
            total += this.chartData[key];
        }
        return total;
    }
    get labels() {
        let vv = [];
        for (let key in this.chartData) {
            vv.push(key);
        }
        return vv;
    }
    get values() {
        let vv = [];
        for (let key in this.chartData) {
            vv.push((this.chartData[key] / this.sum) * 100);
        }
        return vv;
    }
    get chartRenderData() {
        let res = {
            labels: this.labels,
            datasets: [{
                    borderColor: dbBackground,
                    backgroundColor: ["#f08262", "#f36c58", "#f36c58", "#ef5350", "#c73f3c"],
                    data: this.values
                }]
        };
        return res;
    }
    get chartOptions() {
        let res = {
            maintainAspectRatio: false,
            responsive: true,
            legend: {
                display: false,
            },
            scales: {
                xAxes: [{
                        gridLines: {
                            color: '#444',
                            // drawBorder: true,
                            borderDash: [2, 2],
                        },
                        ticks: {
                            suggestedMin: 0,
                            suggestedMax: 100,
                            callback: (v) => v + ' %'
                        }
                    }],
                yAxes: [{
                        barPercentage: 0.6,
                        categoryPercentage: 1,
                        stacked: true,
                        position: 'left',
                    }]
            },
            barPercentage: 80,
            categoryPercentage: 100,
            barThickness: 'flex',
            color: '#fff',
        };
        return res;
    }
    updateData() {
        let chart = this.$data._chart;
        if (chart) {
            chart.destroy();
            this.$emit('chart:destroy');
        }
        this.renderChart(this.chartRenderData, this.chartOptions);
        this.$emit('chart:render');
    }
    mounted() {
        this.updateData();
    }
};
tslib_1.__decorate([
    Prop({ required: true })
], chart.prototype, "chartData", void 0);
tslib_1.__decorate([
    Watch('chartData')
], chart.prototype, "watchChartData", null);
chart = tslib_1.__decorate([
    Component({ extends: HorizontalBar })
], chart);
export default chart;
